import { render, staticRenderFns } from "./submitted_details.vue?vue&type=template&id=60de8a89&scoped=true"
import script from "./submitted_details.vue?vue&type=script&lang=js"
export * from "./submitted_details.vue?vue&type=script&lang=js"
import style0 from "./submitted_details.vue?vue&type=style&index=0&id=60de8a89&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60de8a89",
  null
  
)

export default component.exports